import { render, staticRenderFns } from "./landTrust.vue?vue&type=template&id=2aa76c46&scoped=true"
import script from "./landTrust.vue?vue&type=script&lang=js"
export * from "./landTrust.vue?vue&type=script&lang=js"
import style0 from "./landTrust.vue?vue&type=style&index=0&id=2aa76c46&prod&lang=less&scoped=true"
import style1 from "./landTrust.vue?vue&type=style&index=1&id=2aa76c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa76c46",
  null
  
)

export default component.exports